import {
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableHeader,
	TableRow,
} from "@/components/ui/table";

type ClientEquipment = {
	brand?: string | null;
} | null;

type RepairSummary = {
	repairNumber?: string | number | null;
	clientEquipment?: ClientEquipment;
	value?: number | null;
} | null;

type TodayRepairEntry = {
	repair?: RepairSummary;
	totalMaterial?: number | null;
	value?: number | null;
};

type TodayRepairsTableProps = {
	repairs?: TodayRepairEntry[];
};

const formatCurrency = (value: number) =>
	new Intl.NumberFormat("pt-PT", {
		style: "currency",
		currency: "EUR",
		maximumFractionDigits: 2,
	}).format(value);

const normalizeNumber = (value: number | null | undefined) => {
	const parsed = Number(value ?? 0);
	return Number.isNaN(parsed) ? 0 : parsed;
};

const formatEquipmentLabel = (equipment: ClientEquipment) => {
	if (!equipment) {
		return "-";
	}

	return equipment.brand?.trim() || "-";
};

export function TodayRepairsTable({ repairs = [] }: TodayRepairsTableProps) {
	return (
		<div className="overflow-hidden rounded-lg border border-border/60 bg-card/70">
			<Table>
				<TableHeader>
					<TableRow className="bg-muted/50">
						<TableHead className="w-[180px]">#Rep</TableHead>
						<TableHead className="w-[180px]">Equipamento</TableHead>
						<TableHead className="w-[180px]">Material</TableHead>
						<TableHead className="w-[180px]">Valor da Reparação</TableHead>
						<TableHead className="w-[180px]">Comissão</TableHead>
					</TableRow>
				</TableHeader>
				<TableBody>
					{repairs.map((entry) => {
						const repairNumber = entry.repair?.repairNumber ?? "-";
						const equipmentLabel = formatEquipmentLabel(
							entry.repair?.clientEquipment ?? null,
						);
						const rowKey = `${repairNumber}-${equipmentLabel}-${
							entry.value ?? "value"
						}`;

						return (
							<TableRow key={rowKey}>
								<TableCell>{repairNumber}</TableCell>
								<TableCell>{equipmentLabel}</TableCell>
								<TableCell>
									{formatCurrency(normalizeNumber(entry.totalMaterial))}
								</TableCell>
								<TableCell>
									{formatCurrency(normalizeNumber(entry.repair?.value))}
								</TableCell>
								<TableCell>
									{formatCurrency(normalizeNumber(entry.value))}
								</TableCell>
							</TableRow>
						);
					})}
				</TableBody>
			</Table>
		</div>
	);
}
